import img from "../../assets/svgs/svg1.svg";
import img2 from "../../assets/svgs/svg3.svg";
import img3 from "../../assets/svgs/svg7.svg";

export const InfoData1 = {
  id: "about",

  lightText: false,
  lightTextDesc: false,
  topLine: "Acessibilidade a educação",
  headline:
    "Acesso a cursos profissionalizantes de qualidade de forma gratuíta ",
  description:
    "A educa+ é uma plataforma de ensino totalmente gratuita que oferece diversas bolsas de estudos graças aos nossos parceiros",

  ImgFirst: true,
  img: img,
  alt: "Sobre",
};

export const InfoData2 = {
  id: "proposal",

  topLine: "Seja contratado por nossos parceiros",
  headline:
    "Estudando conosco você tem acesso a vagas de emprego exclusivas para alunos da plataforma",
  description:
    "Ao se formar na especialização você pode trabalhar com um de nossos parceiros, tenha acesso as mais diversas oportunidades!",

  ImgFirst: false,
  img: img2,
  alt: "Proposta",
};

export const InfoData3 = {
  id: "services",

  topLine: "Bolsas de estudos",
  headline:
    "Nossa plaforma oferece cursos profissionalizantes com certificados",
  description:
    "Ao se formar na especialização você pode trabalhar com um de nossos parceiros, tenha acesso as mais diversas oportunidades!",

  ImgFirst: true,
  img: img3,
  alt: "Serviços",
};
